import { useTranslation } from 'react-i18next';
import { Hourglass } from 'lucide-react';
import type { Employee } from '@momentum/types';
import { getFullName } from '@/shared/utils/employee-utils';
import { ParticipantAvatar } from './ParticipantAvatar';

interface ParticipantColumnProps {
  participant: Employee;
}

export function ParticipantColumn({ participant }: ParticipantColumnProps) {
  const { t } = useTranslation('debriefV2');
  const fullName = getFullName(participant) ?? '';

  return (
    <div className="w-[380px] shrink-0 flex flex-col bg-white rounded-2xl border border-slate-200/80 shadow-sm overflow-hidden h-max">
      <div className="p-5 border-b border-slate-100 flex items-center gap-3 shrink-0">
        <ParticipantAvatar employee={participant} size="lg" />
        <div className="min-w-0">
          <h4 className="font-semibold text-slate-900 text-sm truncate">
            {fullName}
          </h4>
        </div>
      </div>
      <div className="p-8 flex flex-col items-center justify-center min-h-[460px] text-slate-400 bg-slate-50/30">
        <Hourglass className="h-10 w-10 mb-3 text-slate-300" aria-hidden />
        <p className="text-sm font-medium">
          {t('lessons.waitingForParticipant')}
        </p>
      </div>
    </div>
  );
}
